import React from 'react';
import styled from 'styled-components';
import PaymentOptionCard from './PaymentOptionCard';

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

/**
 * Reusable list of payment options, each with its logos.
 *
 *   <PaymentOptionList
 *     options={PAYMENT_OPTIONS}   // see paymentOptions.js
 *     value={method}              // selected option id, or null
 *     onChange={setMethod}        // called with the option id
 *     disabled={false}            // lock everything, e.g. while a payment starts
 *   />
 *
 * To make one option unavailable, give it `unavailableReason: 'text'`; it is
 * greyed out and the reason is shown on the card.
 */
const PaymentOptionList = ({ options, value = null, onChange, disabled = false, label = 'Payment method' }) => (
  <List role="radiogroup" aria-label={label}>
    {options.map((option) => (
      <PaymentOptionCard
        key={option.id}
        option={option}
        selected={value === option.id}
        disabled={disabled}
        onSelect={onChange}
      />
    ))}
  </List>
);

export default PaymentOptionList;
